<template>
  <session class="page-protocol">
    <div class="container protocol-container" v-html="Utils.presetHtmlText(content)" />
  </session>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  const route = useRoute();

  import * as Utils from '@/assets/utils.js';

  import * as termContent from './content/term.js';
  import * as privateContent from './content/private.js';
  import * as purchaseContent from './content/purchase.js';

  const content = ref('')

	const getContent = async () => {
		const { target } = route.params;

		// 设置页面标题
		let titleContent = ({
			private: privateContent.title,
			term: termContent.title,
			purchase: purchaseContent.title,
		})[target];
		document.title = titleContent;

		// 设置页面内容
		let textContent = ({
			private: privateContent.content,
			term: termContent.content,
			purchase: purchaseContent.content,
		})[target];
		if(textContent) {
			textContent = textContent.replace(/\n/ig, '<br />');
		}
    content.value = textContent
	};
  onMounted(() => {
    getContent();
  });

</script>

<style scoped lang="less">
@import "index.less";
</style>
